package com.zq.webproject.ui.bankcard


import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.zq.webproject.network.Repository
import com.zq.webproject.utils.TokenManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch

/**
 * 添加银行卡ViewModel
 */
class AddBankCardViewModel {
    private val repository = Repository()
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Main)

    // 加载状态
    var isLoading by mutableStateOf(false)
        private set

    // 错误信息
    var errorMessage by mutableStateOf<String?>(null)
        private set

    // 成功信息
    var successMessage by mutableStateOf<String?>(null)
        private set

    // 添加成功标志
    var addSuccess by mutableStateOf(false)
        private set

    /**
     * 添加银行卡
     */
    fun addBankCard(
        cardNumber: String,
        cardHolderName: String,
        expirationDate: String,
        cvv: String,
        bankName: String
    ) {
        scope.launch {
            val token = TokenManager.getToken()
            if (token.isNullOrEmpty()) {
                println("AddBankCardViewModel - Token为空，无法添加银行卡") // 日志输出
                errorMessage = "未登录，无法添加银行卡"
                return@launch
            }

            // 验证表单
            if (cardNumber.isEmpty()) {
                errorMessage = "请输入银行卡号"
                println("AddBankCardViewModel - 银行卡号为空") // 日志输出
                return@launch
            }

            if (cardNumber.length < 16) {
                errorMessage = "银行卡号长度不正确"
                println("AddBankCardViewModel - 银行卡号长度不正确: ${cardNumber.length}") // 日志输出
                return@launch
            }

            if (cardHolderName.isEmpty()) {
                errorMessage = "请输入持卡人姓名"
                println("AddBankCardViewModel - 持卡人姓名为空") // 日志输出
                return@launch
            }

            if (expirationDate.isEmpty()) {
                errorMessage = "请输入有效期"
                println("AddBankCardViewModel - 有效期为空") // 日志输出
                return@launch
            }

            // 验证有效期格式 YYYY-MM-DD
            if (!expirationDate.matches(Regex("\\d{4}-\\d{2}-\\d{2}"))) {
                errorMessage = "有效期格式不正确，应为：YYYY-MM-DD"
                println("AddBankCardViewModel - 有效期格式错误: $expirationDate") // 日志输出
                return@launch
            }

            if (bankName.isEmpty()) {
                errorMessage = "请输入银行名称"
                println("AddBankCardViewModel - 银行名称为空") // 日志输出
                return@launch
            }

            println("AddBankCardViewModel - 开始添加银行卡") // 日志输出
            println("AddBankCardViewModel - 银行卡号: $cardNumber, 持卡人: $cardHolderName, 有效期: $expirationDate, CVV: $cvv, 银行: $bankName") // 日志输出

            isLoading = true
            errorMessage = null
            successMessage = null

            val result = repository.addBankCard(
                token = token,
                cardNumber = cardNumber,
                cardHolderName = cardHolderName,
                expirationDate = expirationDate,
                cvv = cvv,
                bankName = bankName
            )

            if (result.isFailure) {
                val error = "添加失败: ${result.exceptionOrNull()?.message}"
                println("AddBankCardViewModel - $error") // 日志输出
                errorMessage = error
                isLoading = false
                return@launch
            }

            val response = result.getOrNull()
            if (response?.success == true) {
                successMessage = response.message
                addSuccess = true
                println("AddBankCardViewModel - 银行卡添加成功: ${response.message}") // 日志输出
                println("AddBankCardViewModel - 返回的银行卡信息: ${response.bankCard}") // 日志输出
            } else {
                errorMessage = response?.message ?: "添加失败"
                println("AddBankCardViewModel - 添加失败: ${response?.message}") // 日志输出
            }

            isLoading = false
        }
    }

    /**
     * 清除错误信息
     */
    fun clearError() {
        errorMessage = null
    }

    /**
     * 清除成功信息
     */
    fun clearSuccess() {
        successMessage = null
    }
}